import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { useState } from "react";
import { toast } from "sonner";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useCreateModuleMutation } from "Modules/Api/Mutations/useCreateModuleMutation";
import { usePriceCategoriesQuery } from "Modules/Api/Queries/usePriceCategoriesQuery";
import type { ModuleFormData } from "Modules/Forms/moduleFormSchema";
import { CreateModuleModal } from "./CreateModuleModal";

export const NewModuleButton = (): React.ReactNode => {
  const { t } = useResource();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const createModuleMutation = useCreateModuleMutation();
  const { data: priceCategoriesData, isLoading: isPriceCategoriesLoading } =
    usePriceCategoriesQuery();

  const handleCreateModule = async (moduleData: ModuleFormData) => {
    try {
      await createModuleMutation.mutateAsync({
        name: moduleData.name,
        type: moduleData.type,
        priceCategoryID: moduleData.priceCategoryID,
        customPrompt: moduleData.customPrompt,
        customPromptPlainText: moduleData.customPromptPlainText,
        textLlms: moduleData.textLlms,
        voiceLlms: moduleData.voiceLlms,
      });

      toast.success(t(Resources.Modules.CreateModuleModal.SuccessMessage));
      setIsModalOpen(false);
    } catch {
      // field errors shown in form, non-field errors as toast via useHandleServerError
    }
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setIsModalOpen(true)}
        sx={{ px: Spacing.L }}
      >
        {t(Resources.Common.NewModule)}
      </Button>
      <CreateModuleModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleCreateModule}
        priceCategories={priceCategoriesData?.items ?? []}
        isPriceCategoriesLoading={isPriceCategoriesLoading}
        serverError={createModuleMutation.error}
      />
    </>
  );
};
